export interface CampoJuegoTipoJSON {
  cjt_id: string | null;
  cjt_descripcion: string;
  cjt_activo: boolean;
}

export class CampoJuegoTipo {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: CampoJuegoTipo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: CampoJuegoTipoJSON) {
    return CampoJuegoTipo.createFrom(entity.cjt_id, entity.cjt_descripcion, entity.cjt_activo);
  }

  toJSON(): CampoJuegoTipoJSON {
    return {
      cjt_id: this.getId(),
      cjt_descripcion: this.getDescripcion(),
      cjt_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
